import React, { useState, useEffect } from "react";
import styles from "./index.module.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import Tesla from "img/Tesla.jpg";

// ── Image Slideshow (no external icon deps) ────────────────────────────────
const ImageSlider = ({ images, name, interval = 3000 }) => {
    const [current, setCurrent] = useState(0);

    // Auto-play: advance every `interval` ms, reset timer on manual click
    useEffect(() => {
        if (!images || images.length <= 1) return;
        const timer = setInterval(() => {
            setCurrent((c) => (c + 1) % images.length);
        }, interval);
        return () => clearInterval(timer);
    }, [images, interval, current]); // reset timer when user clicks manually

    if (!images || images.length === 0) return null;

    if (images.length === 1) {
        return (
            <img className={styles.memberImage} src={images[0]} alt={name} />
        );
    }

    const prev = (e) => {
        e.stopPropagation();
        setCurrent((c) => (c - 1 + images.length) % images.length);
    };

    const next = (e) => {
        e.stopPropagation();
        setCurrent((c) => (c + 1) % images.length);
    };

    return (
        <div className={styles.sliderWrapper}>
            <img
                className={styles.memberImage}
                src={images[current]}
                alt={`${name} ${current + 1}`}
            />
            <button
                className={`${styles.sliderBtn} ${styles.sliderBtnLeft}`}
                onClick={prev}
            >
                &#8249;
            </button>
            <button
                className={`${styles.sliderBtn} ${styles.sliderBtnRight}`}
                onClick={next}
            >
                &#8250;
            </button>
            <div className={styles.sliderDots}>
                {images.map((_, i) => (
                    <span
                        key={i}
                        className={`${styles.dot} ${
                            i === current ? styles.dotActive : ""
                        }`}
                        onClick={() => setCurrent(i)}
                    />
                ))}
            </div>
        </div>
    );
};

// ── Main Component ─────────────────────────────────────────────────────────
const Ceo = () => {
    const lang = useSelector((state) => state.app.lang);
    const { t } = useTranslation();

    const members = [
        {
            name: t("Kai"),
            role: t("KaiRole"),
            imgs: ["/bgImg/Kai.jpg", "/bgImg/Kai3.jpg"], // ← 사진 추가/제거 여기서
            remarks: t("KaiRemarks"),
            linkedIn: "https://www.linkedin.com/in/iltae-lee",
        },
    ];

    return (
        <div className={styles.ceoContainer}>
            <div>
                <div className={styles.topHeader}>{t("CeoGreetingHeader")}</div>
                <p dangerouslySetInnerHTML={{ __html: t("CeoGreetingText") }} />
            </div>
            <div>
                <div className={styles.lastHeader}>{t("BiographyHeader")}</div>
                <ul>
                    <li>{t("Bio1")}</li>
                    <li>{t("Bio2")}</li>
                    <li>{t("Bio3")}</li>
                    <li>{t("Bio4")}</li>
                </ul>
            </div>

            <div className={styles.membersContainer}>
                {members.map((member, index) => (
                    <div key={index} className={styles.memberCard}>
                        <ImageSlider images={member.imgs} name={member.name} />
                        <div className={styles.memberName}>{member.name}</div>
                        <div className={styles.memberRole}>{member.role}</div>
                        {member.remarks && (
                            <>
                                <hr />
                                <div className={styles.memberRemarks}>
                                    {member.remarks}
                                </div>
                            </>
                        )}
                        {member.linkedIn && (
                            <div className={styles.memberLinkedIn}>
                                <a
                                    href={member.linkedIn}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <FontAwesomeIcon icon={faLinkedin} />{" "}
                                    {t("LinkedIn")}
                                </a>
                            </div>
                        )}
                    </div>
                ))}
            </div>

            {lang !== "cn" && (
                <div>
                    <div className={styles.header}>{t("Car")}</div>
                    <div className={styles.carDiv}>
                        {t("CarDesc")}
                        <img
                            src={Tesla}
                            className={styles.logoImg}
                            alt="Tesla"
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Ceo;
